import { ReactNode } from "react";
import FlexLayout from "@jnctn/design-system/Flexbox/FlexLayout.component";
import useIsPortrait from "@jnctn/hooks/useIsPortrait";
import cx from "classnames";
import styles from "./Notices.module.css";

export default function Notices({
  hasMenu,
  children,
}: {
  hasMenu: boolean;
  children: ReactNode;
}) {
  const isPortrait = useIsPortrait();

  return (
    <FlexLayout
      direction="vertical"
      justify="center"
      align="center"
      className={cx("absolute right-4 z-10 space-y-3", styles.root, {
        "bottom-24 left-4": isPortrait && hasMenu,
        "bottom-4 left-20": !isPortrait && hasMenu,
        "bottom-4 left-4": !hasMenu,
      })}
    >
      {children}
    </FlexLayout>
  );
}
